import { Reservation, ServiceBooking } from "@turizi/shared";
import { useTranslation } from "react-i18next";
import ServiceDatePopover from "../service-date-popover";
import { TimePicker } from "@mantine/dates";
import { IconClock } from "@tabler/icons-react";
import { SERVICE_CATEGORIES } from "@turizi/shared";

interface DataSectionProps {
    booking: ServiceBooking | undefined;
    reservation?: Reservation;
    save: (data: Partial<ServiceBooking>) => void;
    saving: boolean;
    className?: string;
    editble?: boolean;
}


export default function DataSection({
    booking,
    reservation,
    save,
    saving,
    className,
    editble = true,
}: DataSectionProps) {
    const { t } = useTranslation();

    if (!booking) return null;

    return (
        <div>
            <div className={className || 'space-y-2'}>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 solid-box-border-blue w-full min-w-0">
                    <div className="flex-1 min-w-0">
                        <ServiceDatePopover
                            // loading={saving} // the loading animation is in the close button already
                            icon={true}
                            label={t('date')}
                            className="solid-box-border-hover min-h-9"
                            size="lg"
                            limits={[reservation?.start_day, reservation?.end_day]}
                            serviceCategory={booking?.service_data?.category}
                            value={[booking.start_day, booking.end_day]}
                            onChange={(value) => save({ start_day: value[0], end_day: value[1] })}
                            disabled={!editble}
                        />
                    </div>
                    <div className="flex gap-1 shrink-0">
                        <TimePicker
                            label={booking.service_data.category === SERVICE_CATEGORIES.stay ? t('check_in') : t('start')}
                            disabled={!editble}
                            size="sm"
                            radius="md"
                            withDropdown={true}
                            withSeconds={false}
                            value={booking?.start_hour || ''}
                            onChange={(value) => save({ start_hour: value?.substring(0, 5) })}
                            leftSection={<IconClock size={12} />}
                            className="font-bold"
                        />
                        <TimePicker
                            label={booking.service_data.category === SERVICE_CATEGORIES.stay ? t('check_out') : t('end')}
                            disabled={!editble}
                            size="sm"
                            radius="md"
                            withDropdown={true}
                            withSeconds={false}
                            value={booking?.end_hour || ''}
                            onChange={(value) => save({ end_hour: value?.substring(0, 5) })}
                            leftSection={<IconClock size={12} />}
                        />
                    </div>
                </div>
            </div>
        </div >
    );
}